import { render, staticRenderFns } from "./transaction_types.vue?vue&type=template&id=694252e0&scoped=true&"
import script from "./transaction_types.vue?vue&type=script&lang=js&"
export * from "./transaction_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694252e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694252e0')) {
      api.createRecord('694252e0', component.options)
    } else {
      api.reload('694252e0', component.options)
    }
    module.hot.accept("./transaction_types.vue?vue&type=template&id=694252e0&scoped=true&", function () {
      api.rerender('694252e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/transaction_types.vue"
export default component.exports